import { FC, Fragment, useEffect } from 'react'
import { useParams } from 'react-router-dom';
// Hooks
import useToggle from 'hooks/useToggle';
// Store
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { getQuiz, assignSpotPrizeWinner } from 'store/quiz/quizzesAsync';
// Selectors
import { selectQuiz, selectLoading } from 'store/quiz/quizzesSelectors';
import { getReportItems } from 'store/result/resultSelectors';
// Types
import QuizTypes from 'types/QuizTypes';
// Icons
import { FaCrown } from 'react-icons/fa';
// Components
import { Button } from 'components/Buttons';
import { Loader } from 'components/Utilities';
import { Tooltip } from 'components/Tooltip';
import ConfirmationDialog from 'dialogs/Confirmation.dialog';
// i18next
import { useTranslation } from 'react-i18next';

const ReportSpotPrizeAssign:FC = () => {
  const { t } = useTranslation();
  const { quizId } = useParams<{ quizId:string }>();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const loading:boolean = useAppSelector(selectLoading);
  const reportItems = useAppSelector(getReportItems);

  useEffect(() => {
    dispatch(getQuiz(quizId));
    // return () => {
    //   dispatch(QuizActions.setInitialField('item'));
    // }
    // eslint-disable-next-line
  }, []);

  const { open, toggle } = useToggle();

  const handleAssignSpotPrizeWinner = () => dispatch(assignSpotPrizeWinner(quizId));

  const onClick = () => {
    if (!!quiz.spotPrizeWinners?.length) {
      toggle();
    } else {
      handleAssignSpotPrizeWinner();
    }
  }

  const buttonIsDisabled = (quiz && (!quiz.spotPrizesEnabled || !quiz.spotPrizes || quiz.spotPrizes.length === 0)) || (reportItems && reportItems.length === 0);

  if ( !quiz ) return <Loader />;
  if ( [QuizTypes.Personality].includes(quiz.type) ) return null;
  return (
    <Fragment>
      <div className="flex items-center py-2">
        <div className="pr-4">
          <Button
            variant="contained"
            loading={loading}
            disabled={buttonIsDisabled}
            onClick={onClick}
          >{t('pages.quizReport.assignRandomPrizeButton')}</Button>
        </div>
        <div className="text-white">
          {quiz.spotPrizeWinners && quiz.spotPrizeWinners.length > 0 ? (
            quiz.spotPrizeWinners.map((winner:any) => (
              <div key={`winner-item-${winner._id}`} className="flex items-center border-l border-gray-50">
                <span
                  className="text-xl px-4 text-primary"
                ><Tooltip title={t('pages.quizReport.winnerLabel')}><FaCrown /></Tooltip></span>
                <div className="flex flex-col text-white text-opacity-80 pr-4">
                  {winner.username ? (
                    <span className="font-bold">{winner.username}</span>
                  ) : (
                    <Fragment>
                      <span className="text-sm font-light">{winner.email}</span>
                      <span className="font-bold">{`${winner.name} ${winner.surname}`}</span>
                    </Fragment>
                  )}
                </div>
              </div>
            ))
          ) : null}
        </div>
      </div>
      <span className="block text-gray-400 text-sm font-light leading-5 mb-4">{t('pages.quizReport.assignRandomPrizeButtonHint')}</span>

      <ConfirmationDialog
        open={open}
        onClose={toggle}
        title={t('pages.quizReport.assignRandomPrizeTitle')}
        content={t('pages.quizReport.assignRandomPrizeConfirmation')}
        loading={loading}
        onConfirm={handleAssignSpotPrizeWinner}
      />
    </Fragment>
  )
}

export default ReportSpotPrizeAssign;
